import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { OrgId } from 'app/common/types/id'

import { SubsidyOrdersSettingsApplyButton } from './SubsidyOrdersSettingsApplyButton'
import styles from './AccordionItemHeaderActive.scss'

type Props = {
  ID: string
  orgId: OrgId
  locked?: boolean
  onCreateFormID: (ID: string) => string
  onCancel: () => void
  modified?: boolean
  app: 'cafeteria' | 'compensation' | 'camp'
  hideSubsidyOrdersSettingsApplyButton?: boolean
}

const AccordionItemHeaderActive = ({
  ID,
  orgId,
  locked,
  onCreateFormID,
  onCancel,
  modified = false,
  app,
  hideSubsidyOrdersSettingsApplyButton = false,
}: Props) => {
  const formID = onCreateFormID(ID)

  return (
    <ControlsBar className={styles.root}>
      {!modified && app !== 'camp' && !hideSubsidyOrdersSettingsApplyButton && (
        <SubsidyOrdersSettingsApplyButton orgId={orgId} allowance={ID} orderType={app} />
      )}

      {modified && (
        <>
          <PlainButton onClick={onCancel} outline>
            {'Отмена'}
          </PlainButton>
          <PlainButton type="submit" disabled={locked} form={formID}>
            {'Сохранить'}
          </PlainButton>
        </>
      )}
    </ControlsBar>
  )
}

export default AccordionItemHeaderActive
